module.exports = __webpack_public_path__ + "img/l1.6da05077.jpg";